import { type ChangeEvent, useCallback } from 'react';
import get from 'lodash/get';
import { CFormInput, CFormFeedback, CInputGroup, CInputGroupText } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import type { IFieldComponentProps } from 'components/inputs/types';

interface IAuthInputProps extends IFieldComponentProps<string> {
  /** An icon of @coreui/icons. */
  icon?: string[];
  label?: string;
  type?: string;
}

const AuthInput = ({ icon, label, type, field, form }: IAuthInputProps) => {
  const { name } = field;
  const { touched, errors, setFieldValue, setFieldTouched } = form;

  const invalid = Boolean(get(touched, name) && get(errors, name));

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setFieldValue(name, e.target.value);
    },
    [name, setFieldValue],
  );

  // formik 1's handleBlur took the call without an event (it marked an `undefined` path touched and validated);
  // formik 2's reads the event's target and throws without one. setFieldTouched marks the field and validates.
  const handleOnBlur = useCallback(() => {
    setFieldTouched(name, true);
  }, [name, setFieldTouched]);

  return (
    <div className="mb-3">
      <CInputGroup className="mb-3">
        <CInputGroupText>
          <CIcon icon={icon} />
        </CInputGroupText>
        <CFormInput
          {...field}
          type={type}
          onBlur={handleOnBlur}
          onChange={handleChange}
          name={name}
          placeholder={label}
          invalid={invalid}
        />
      </CInputGroup>
      {/* d-block: Bootstrap shows .invalid-feedback only as a sibling of an .is-invalid input, and the input is
          inside the input group. */}
      {invalid && (
        <CFormFeedback invalid className="help-block d-block">
          {errors[name]}
        </CFormFeedback>
      )}
    </div>
  );
};
export default AuthInput;
